<ng-template #formFactorsModal>
   <div id="formFactor" dir={{direction}}>
      <div id="closebtn" (click)="close(true)" class=" close close_icon cursor-pointer" data-dismiss="modal">
         <img src="assets/images/popup_close_button.svg" alt="close" />
      </div>
      <div id="formModalBody" class="modal-body popup-body">
         <div id="formHeading" class="heading" i18n="@@form-factors.body.apply-content-group-to">Apply content group to</div>
         <div id="formLabel" class="mb-3 mt-n3 color-grey" i18n="@@form-factors.body.all-columns-shown-below-are-required">All columns
            shown
            below are required.</div>
         <div id="deviceTable" class="form_factor_table">
            <div id="deviceCol" class="form_factor_column">
               <form [formGroup]="deviceTypesForm">
                  <div id="deviceTypes"class="factor_type">{{deviceTypes}}</div>
                  <div id="deviceFormGrp" class="form-group mt-2 mb-4">
                     <input type="checkbox" [checked]="selectAllDeviceChecked"
                        (change)="onSelectAllDeviceCheckboxChange($event)" id="selectAllDeviceTypes" />
                     <label for="selectAllDeviceTypes" [innerHTML]="selectAll"></label>
                  </div>
                  <div  id="deviceCheckbox" class="factor_check form-group" formArrayName="deviceTypes"
                     *ngFor="let order of deviceTypesFormArray.controls; let i = index">
                     <input type="checkbox" [formControlName]="i" />
                     <label for="i">{{formFactorsConfigData.deviceTypes[i].name}}</label>
                  </div>
               </form>
            </div>
            <!-- Manufacturers -->
            <div id="manufacturersForm" class="form_factor_column">
               <form [formGroup]="manufacturersForm">
                  <div id="manufactures" class="factor_type">{{manufacturers}}</div>
                  <div id="manufacturerFormGrp" class="form-group mt-2 mb-4">
                     <input type="checkbox" [checked]="selectAllManufacChecked"
                        (change)="onSelectAllManufacCheckboxChange($event)" id="selectAllManufac" />
                     <label for="selectAllManufac" [innerHTML]="selectAll"></label>
                  </div>
                  <div id="manufacturesCheckbox" class="factor_check form-group" formArrayName="manufacturers"
                     *ngFor="let order of manufacturersFormArray.controls; let i = index">
                     <input type="checkbox" [formControlName]="i" />
                     <label for="i">{{formFactorsConfigData.manufacturers[i].name}}</label>
                  </div>
               </form>
            </div>
            <!-- Processors -->
            <div id="processorsForm" class="form_factor_column">
               <form [formGroup]="processorsForm">
                  <div id="processors" class="factor_type">{{processors}}</div>
                  <div id="processorsFormGrp" class="form-group mt-2 mb-4">
                     <input type="checkbox" [checked]="selectAllProcChecked"
                        (change)="onSelectAllProcCheckboxChange($event)" id="selectAllProc" [disabled]="selectAllProcDisabled"/>
                     <label for="selectAllProc" [innerHTML]="selectAll"></label>
                  </div>
                  <div id="processorsCheckbox" class="factor_check form-group" formArrayName="processors"
                     *ngFor="let order of processorsFormArray.controls; let i = index">
                     <input type="checkbox" [formControlName]="i" />
                     <label for="i">{{formFactorsConfigData.processors[i].name}}</label>
                  </div>
               </form>
            </div>
            <!-- Generations -->
            <div id="generationsForm" class="form_factor_column">
               <form [formGroup]="generationsForm">
                  <div id="generations" class="factor_type">{{generations}}</div>
                  <div id="generationsFormGrp" class="form-group mt-2 mb-4">
                     <input type="checkbox" [checked]="selectAllGenChecked"
                        (change)="onSelectAllGenCheckboxChange($event)" id="selectAllGens" />
                     <label for="selectAllGens" [innerHTML]="selectAll"></label>
                  </div>
                  <div id="generationsCheckbox" class="factor_check form-group" formArrayName="generations"
                     *ngFor="let order of generationsFormArray.controls; let i = index">
                     <input type="checkbox" [formControlName]="i" />
                     <label for="i">{{formFactorsConfigData.generation[i].name}}</label>
                  </div>
               </form>
            </div>
         </div>
      </div>
      <div id="footer" class="modal-footer">
         <div *ngIf="noOneSelected" class="color-red error-message">
            <img src="assets/images/icon_exclamation_circle.svg" alt="exclamation" />
            <span class='error-message-padding' *ngIf="errorColumns.length === 1"
               i18n="@@form-factors.footer.error.column-can-not-empty">{{errorColumns[0]}} column can’t be empty</span>
            <span class='error-message-padding' *ngIf="errorColumns.length === 2"
               i18n="@@form-factors.footer.error.columns-can-not-empty">{{errorColumns[0]}} and {{errorColumns[1]}}
               columns can’t be empty</span>
            <span class='error-message-padding' *ngIf="errorColumns.length === 3"
               i18n="@@form-factors.footer.error.two-columns-can-not-empty">{{errorColumns[0]}}, {{errorColumns[1]}} and
               {{errorColumns[2]}} columns can’t be empty</span>
            <span class='error-message-padding' *ngIf="errorColumns.length === 4"
               i18n="@@form-factors.footer.three-columns-can-not-empty">{{errorColumns[0]}}, {{errorColumns[1]}},
               {{errorColumns[2]}} and {{errorColumns[3]}} columns can’t be empty</span>
         </div>
         <button type="button" i18n="@@form-factors.footer.cancel"
            class="btn btn-outline-primary btn-lg gtmApplyFormFactorsCancel" data-dismiss="modal"
            (click)="close(true)">Cancel</button>
         <button type="button" i18n="@@form-factors.footer-save.save-selections" [disabled]="noOneSelected"
            class="btn btn-primary btn-lg gtmApplyFormFactors" (click)="formSubmit()">Save Selections</button>
      </div>
   </div>
</ng-template>
